import { render, staticRenderFns } from "./SubmissionComponent.vue?vue&type=template&id=1b4cb46d&scoped=true&style=background%3A%20%23FAFAFA%3B&"
import script from "./SubmissionComponent.vue?vue&type=script&lang=js&"
export * from "./SubmissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionComponent.vue?vue&type=style&index=0&id=1b4cb46d&lang=scss&scoped=true&"
import style1 from "./SubmissionComponent.vue?vue&type=style&index=1&id=1b4cb46d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4cb46d",
  null
  
)

export default component.exports